import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  if (response.status === 200) {
    return response.data
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 把data序列化一下
axios.interceptors.request.use((config) => {
  config.data = qs.stringify(config.data)
  return config
}, function(error) {
  return Promise.reject(error)
})

/**
 *
 * @param url {string}
 * @param data {object}
 * @param config {object}®
 * @returns {Promise<void>}
 */
const req = async (url, data = {}, config = {}) => {
  if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = '/'
  } else {
    axios.defaults.baseURL = '/'
  }

  let paramsDef = {
    timestamp: Date.now(),
    language: 0
  }
    // sign设置，所有参数按字母升序排序+facephone, AES加密再MD5加密
    // let params = Object.assign({}, paramsDef, data)
    let configDef = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
    }

    let cfg = Object.assign({}, configDef, config)
  // data里面才是body的参数，params是query的参数
    const res = await axios.post(url, data, {
      paramsDef,
      ...cfg
    })
    if (res.code === 1000) {
      return res.data
    } else {
      return Promise.reject(res)
    }
}
export default req



// WEBPACK FOOTER //
// ./src/config/requ.axios.config.js